import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrLabel } from ".";
import { GrStack } from "../layout";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import classNames from "classnames";
import { GrHelperMessage } from "./GrHelperMessage";
const StyledTextField = styled(TextField, { shouldForwardProp: propsName => propsName !== "color" })(({ style, size, error, disabled, multiline = false, variant = "outlined", readOnly, maxRows }) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        ".MuiInputBase-root": {
            height: maxRows
                ? "100%"
                : (style === null || style === void 0 ? void 0 : style.height) ||
                    (!multiline && size === "large" && "40px") ||
                    (!multiline && size === "medium" && "32px") ||
                    (!multiline && size === "small" && "24px") ||
                    (multiline && size === "large" && "82px") ||
                    (multiline && size === "medium" && "78px") ||
                    (multiline && size === "small" && "74px") ||
                    undefined,
            borderRadius: (_a = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _a !== void 0 ? _a : "6px",
            backgroundColor: (disabled || readOnly) && variant === "outlined" ? palette.bg010 : palette.white,
            "&:hover": {
                ".MuiOutlinedInput-notchedOutline": {
                    borderColor: palette.grey030,
                },
            },
        },
        ".MuiInputBase-multiline": {
            padding: 0,
        },
        ".MuiInputBase-input": {
            boxSizing: "border-box",
            border: "none",
            borderWidth: "0",
            height: "100%",
            padding: "6px 10px",
            color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : ((readOnly && palette.grey060) || palette.grey090),
            ...(size === "large" && { padding: "9px 8px" }),
            ...typography[size === "large" ? "Content.Subtitle02" : size === "medium" ? "Content.Subtitle03" : "Content.Subtitle04"],
            caretColor: (_c = style === null || style === void 0 ? void 0 : style.caretColor) !== null && _c !== void 0 ? _c : (error ? palette["negative-secondary"] : palette["maven-blue-dark"]),
            "&::placeholder": {
                color: (readOnly && palette.grey030) || palette.grey040,
            },
            "&::-webkit-scrollbar": {
                width: 8,
                backgroundColor: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: palette.grey030,
                borderRadius: 8,
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent",
            },
            "::placeholder": {
                color: (readOnly && palette.grey060) || (disabled && palette.grey030) || palette.grey040,
                opacity: 1,
            },
        },
        ".MuiOutlinedInput-notchedOutline": {
            borderWidth: !(style === null || style === void 0 ? void 0 : style.border) ? (_d = style === null || style === void 0 ? void 0 : style.borderWidth) !== null && _d !== void 0 ? _d : "1px !important" : undefined,
            borderColor: !(style === null || style === void 0 ? void 0 : style.border)
                ? (_e = style === null || style === void 0 ? void 0 : style.borderColor) !== null && _e !== void 0 ? _e : ((error && palette["negative-secondary"]) || `${palette.grey025} !important`)
                : undefined,
            border: style === null || style === void 0 ? void 0 : style.border,
        },
        ":hover": {
            ".MuiOutlinedInput-notchedOutline": {
                border: !readOnly && !disabled ? `1px solid ${palette.grey040} !important` : undefined,
            },
        },
        ".Mui-focused": {
            ".MuiOutlinedInput-notchedOutline": {
                border: !readOnly && !disabled ? `1px solid ${palette["maven-blue-dark"]} !important` : `1px solid ${palette.grey025} !important`,
            },
        },
        ".Mui-disabled": {
            "::before": {
                borderBottomStyle: (_f = style === null || style === void 0 ? void 0 : style.borderBottomStyle) !== null && _f !== void 0 ? _f : "solid",
            },
            WebkitTextFillColor: palette.grey030,
        },
        ...style,
        width: "100% !important",
    });
});
export function GrTextField({ size = "medium", label, required, startAdornment, endAdornment, helperText, readOnly, minLength, maxLength, className, fullWidth, autoComplete, error, ...props }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const getMultilineRows = (() => {
        var _a;
        const DEFAULT_ROWS = 3;
        if (((_a = props.style) === null || _a === void 0 ? void 0 : _a.height) || props.rows) {
            return props.rows;
        }
        if (props.maxRows) {
            return undefined;
        }
        return DEFAULT_ROWS;
    })();
    return (_jsxs(GrStack, { className: "GrTextField-wrapper", display: "inline-flex", flexDirection: (_a = label === null || label === void 0 ? void 0 : label.flexDirection) !== null && _a !== void 0 ? _a : "column", gap: (_b = label === null || label === void 0 ? void 0 : label.gap) !== null && _b !== void 0 ? _b : (((_c = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _c === void 0 ? void 0 : _c.includes("row")) ? "24px" : "6px"), width: fullWidth ? "100%" : (_e = (_d = props.style) === null || _d === void 0 ? void 0 : _d.width) !== null && _e !== void 0 ? _e : "267px", children: [(label === null || label === void 0 ? void 0 : label.text) && (_jsx(GrLabel, { style: {
                    margin: ((_f = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _f === void 0 ? void 0 : _f.includes("row")) ? "6px 0 0 0" : "0",
                    padding: "0 2px",
                    ...label === null || label === void 0 ? void 0 : label.style,
                }, required: required, disabled: props.disabled, text: label.text, size: ((_g = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _g === void 0 ? void 0 : _g.includes("row")) ? size : "extraSmall" })), _jsxs(GrStack, { flexDirection: (_h = helperText === null || helperText === void 0 ? void 0 : helperText.flexDirection) !== null && _h !== void 0 ? _h : "column", gap: (_j = helperText === null || helperText === void 0 ? void 0 : helperText.gap) !== null && _j !== void 0 ? _j : "6px", width: "100%", children: [_jsx(StyledTextField, { autoComplete: "off", autoFocus: props.autoFocus, error: error, className: classNames("GrTextField", className), size: size, InputProps: {
                            startAdornment,
                            endAdornment,
                            readOnly,
                            autoComplete,
                        }, readOnly: readOnly, inputProps: { maxLength, minLength }, fullWidth: fullWidth, rows: getMultilineRows, ...props }), (helperText === null || helperText === void 0 ? void 0 : helperText.text) && (_jsx(GrHelperMessage, { disabled: props.disabled, error: error, text: helperText.text, style: helperText === null || helperText === void 0 ? void 0 : helperText.style, hasIcon: helperText.hasIcon }))] })] }));
}
//# sourceMappingURL=GrTextField.js.map